export default function SimulatorTitle() {
  return (
    <section className="blade-padding-top">
      <section className=" max-w-xl lg:max-w-7xl mx-auto w-11/12 px-2 md:px-4">
        <h3 className="text-center font-gilroy">
          Smooth and optimized EV charger deployment with VerdeMobility's EV Simulator
        </h3>
      </section>
    </section>
  );
}
